import { render } from "./AddPropertyPage.vue?vue&type=template&id=7b8e3e3b&ts=true"
import script from "./AddPropertyPage.vue?vue&type=script&lang=ts"
export * from "./AddPropertyPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__